export const ASSETINSPECTION_LOADING = "ASSETINSPECTION_LOADING";
export const ASSETINSPECTION_RESET = "ASSETINSPECTION_RESET";
export const GET_ASSETINSPECTION = "GET_ASSETINSPECTION";
export const GET_ASSETINSPECTION_SUCCESS = "GET_ASSETINSPECTION_SUCCESS";
export const GET_ASSETINSPECTION_FAIL = "GET_ASSETINSPECTION_FAIL";
export const DELETE_ASSETINSPECTION = "DELETE_ASSETINSPECTION"
export const DELETE_ASSETINSPECTION_SUCCESS = "DELETE_ASSETINSPECTION_SUCCESS"
export const DELETE_ASSETINSPECTION_FAIL = "DELETE_ASSETINSPECTION_FAIL"
export const UPDATE_ASSETINSPECTION = "UPDATE_ASSETINSPECTION"
export const UPDATE_ASSETINSPECTION_SUCCESS = "UPDATE_ASSETINSPECTION_SUCCESS"
export const UPDATE_ASSETINSPECTION_FAIL = "UPDATE_ASSETINSPECTION_FAIL"
export const ADD_NEW_ASSETINSPECTION = "ADD_NEW_ASSETINSPECTION"
export const ADD_ASSETINSPECTION_SUCCESS = "ADD_ASSETINSPECTION_SUCCESS"
export const ADD_ASSETINSPECTION_FAIL = "ADD_ASSETINSPECTION_FAIL"
export const ASSETINSPECTION_RESET_CREATE = "ASSETINSPECTION_RESET_CREATE"